
export default {
  data() {
    return {
      lockedByGL: false,
      reforecastLocked: false,
      userCanEdit: false,
      userCanEditApproved: false,
      userCanEditPublished: false,
      status: false,
      readonlyStatuses: ['archived'],
      approvedStatuses: ['approved', 'pending', 'pending approval'],
      pendingStatus: 'pending',
      publishedStatuses: ['published']
    }
  },
  methods: {
    displayDeniedMessage: function () {
      var message = '';
      if (this.readonlyDueToStatus) {
        message = `This action cannot be taken when the budget is in the ${this.status} status.`;
      }
      else if (this.readonlyDueToReforecastLock) {
        message = 'This action cannot be taken due to a locked reforecast.'
      }
      else if (this.readonlyDueToGLLock) {
        message = 'This action cannot be taken because the GPR, Loss/Gain to Lease and/or Vacancy Loss GL Accounts are locked.'
      }

      if (message) {
        this.$eventHub.$emit('showAlertNotification', message);
      }
    }
  },
  computed: {
    readonly: function () {
      return this.readonlyDueToReforecastLock || this.readonlyDueToStatus || this.readonlyDueToGLLock
        ;
    },
    readonlyDueToReforecastLock: function () {
      return this.reforecastLocked;
    },
    readonlyDueToStatus: function () {
      return !this.userCanEdit || (
        this.readonlyStatuses.indexOf((this.status || '').toLowerCase()) !== -1 ||
        (this.approvedStatuses.indexOf((this.status || '').toLowerCase()) !== -1 && !this.userCanEditApproved) ||
        ((this.status || '').toLowerCase().startsWith(this.pendingStatus) && !this.userCanEditApproved) ||
        (this.publishedStatuses.indexOf((this.status || '').toLowerCase()) !== -1 && !this.userCanEditPublished)
      );
    },
    readonlyDueToGLLock: function () {
      return this.lockedByGL;
    }
  }
}
